import { LANGUAGE_KEY } from '../../core/constants/language';

/**
 * 中文语言包
 */
export const ZH_CN_LANGUAGE = {
  [LANGUAGE_KEY.LAST_RECHARGE]: "最近充值",
  [LANGUAGE_KEY.LAST_LOGIN]: "最近登录",
  [LANGUAGE_KEY.CURRENT_ROLE]: "当前角色",
  [LANGUAGE_KEY.CONFIRM]: "确定",

  // 支付
  [LANGUAGE_KEY.SELECT_PAYMENT_METHOD]: "请选择支付方式",
  [LANGUAGE_KEY.PAYMENT_BTN]: "立即支付",
  [LANGUAGE_KEY.PAYMENT_ALIPAY]: "支付宝支付",
  [LANGUAGE_KEY.PAYMENT_WECHAT]: "微信支付",
  [LANGUAGE_KEY.PAYMENT_HUABEI]: "花呗支付",
  [LANGUAGE_KEY.PAYMENT_ALIPAY_QRCODE]: "支付宝扫码",
  [LANGUAGE_KEY.PAYMENT_WECHAT_QRCODE]: "微信扫码",
  [LANGUAGE_KEY.PAYMENT_APPLE]: "苹果支付",
  [LANGUAGE_KEY.PAYMENT_APPLE_STOREKIT2]: "苹果StoreKit 2支付",
  [LANGUAGE_KEY.PAYMENT_ONE_STORE]: "oneStore支付",
  [LANGUAGE_KEY.PAYMENT_HUAWEI_OVERSEAS]: "华为支付",
  [LANGUAGE_KEY.PAYMENT_SANSUNG]: "三星支付",
  [LANGUAGE_KEY.PAYMENT_AMAZON]: "Amazon",
  [LANGUAGE_KEY.PAYMENT_AIRWALLEX]: "AirWallex",
  [LANGUAGE_KEY.PAYMENT_THAILAND]: "UniPin",
  [LANGUAGE_KEY.PAYMENT_EUROPE_AMERICA]: "Xsolla",
  [LANGUAGE_KEY.PAYMENT_TAIWAN]: "MyCard",
  [LANGUAGE_KEY.PAYMENT_SOUTHEAST_ASIA]: "PayerMax",
  [LANGUAGE_KEY.PAYMENT_VIETANM]: "Upay",
  [LANGUAGE_KEY.PAYMENT_PAY_PAY]: "PayPay",
  [LANGUAGE_KEY.PAYMENT_PAY_PAL]: "PayPal",
  [LANGUAGE_KEY.PAYMENT_PAY_LETTER]: "PayLetter",
  [LANGUAGE_KEY.PAYMENT_WECHAT_JSSDK]: "微信支付",
  [LANGUAGE_KEY.PAYMENT_WECHAT_H5]: "微信支付",
  [LANGUAGE_KEY.PAYMENT_ALIPAY_MOBILE_WEB]: "支付宝支付",
  [LANGUAGE_KEY.PAYMENT_ALIPAY_PC_WEB]: "支付宝支付",
  [LANGUAGE_KEY.PAYMENT_ALIPAY_INTERNATIONAL_CARD]: "Visa/MasterCard",
  [LANGUAGE_KEY.PAYMENT_ALIPAY_INTERNATIONAL_GOOGLE]: "Google Pay",
  [LANGUAGE_KEY.PAYMENT_ALIPAY_INTERNATIONAL_PAYPAL]: "PayPal",
  [LANGUAGE_KEY.PAYMENT_ALIPAY_INTERNATIONAL_APPLE]: "Apple Pay",
  [LANGUAGE_KEY.PAYMENT_XSOLLA_PAYPAL]: "PayPal",
  [LANGUAGE_KEY.PAYMENT_ALIPAY_INTERNATIONAL]: "Antom",
  [LANGUAGE_KEY.PAYMENT_PAYERMAX_CARD]: "Card",
  [LANGUAGE_KEY.PAYMENT_PAYERMAX_GOOGLE]: "Google Pay",
  [LANGUAGE_KEY.PAYMENT_PAYERMAX_APPLE]: "Apple Pay",
  [LANGUAGE_KEY.PAYMENT_ENJOYPAY_CARD]: "Card",
  [LANGUAGE_KEY.PAYMENT_ENJOYPAY_APPLE]: "Apple Pay",
  [LANGUAGE_KEY.PAYMENT_ENJOYPAY_GOOGLE]: "Google Pay",
  [LANGUAGE_KEY.PAYMENT_ENJOYPAY_PAYPAY]: "PayPay",
};

/**
 * 英文语言包
 */
export const EN_US_LANGUAGE = {
  // 登录+忘记密码
  [LANGUAGE_KEY.TITLE_ACCOUNT_LOGIN]: "Log in",
  [LANGUAGE_KEY.EMAIL_INPUT_PLACEHOLDER]: "Account or Email",
  [LANGUAGE_KEY.PASSWORD_INPUT_PLACEHOLDER]: "Password",
  [LANGUAGE_KEY.VERIFICATION_CODE_INPUT_PLACEHOLDER]: "Verification Code",
  [LANGUAGE_KEY.DESC_LOGIN_BTN]: "Log in",
  [LANGUAGE_KEY.DESC_OTHER_LOGIN_METHOD]: "Other Logins",
  [LANGUAGE_KEY.DESC_RECOVER_PASSWORD]: "Forgot password?",
  [LANGUAGE_KEY.TITLE_RECOVER_PASSWORD]: "Change password",
  [LANGUAGE_KEY.DESC_SEND]: "Get Code",
  [LANGUAGE_KEY.DESC_RESEND]: "Resend",
  [LANGUAGE_KEY.PROMPT_INPUT_EMAIL]: "Email",
  [LANGUAGE_KEY.PROMPT_INPUT_CORRECT_EMAIL]: "Enter a valid account or email",
  [LANGUAGE_KEY.PROMPT_INPUT_PASSWORD]: "Password",
  [LANGUAGE_KEY.PROMPT_INPUT_CORRECT_PASSWORD]: "The password format is incorrect",
  [LANGUAGE_KEY.PROMPT_INPUT_VERIFICATION_CODE]: "Enter verification code",
  [LANGUAGE_KEY.PROMPT_INPUT_CORRECT_VERIFICATION_CODE]: "Please enter the correct verification code",
  [LANGUAGE_KEY.PROMPT_TOAST_SEND_SUCCESS]: "Sent successfully",
  [LANGUAGE_KEY.PROMPT_TOAST_EDIT_SUCCESS]: "Modification successful",
  [LANGUAGE_KEY.TOKEN_EXPIRED_PROMPT]: "Token has expired, please log in again",

  // 角色选择
  [LANGUAGE_KEY.LAST_RECHARGE]: "Recent purchases",
  [LANGUAGE_KEY.LAST_LOGIN]: "Recently logged in",
  [LANGUAGE_KEY.CURRENT_ROLE]: "Current role",
  [LANGUAGE_KEY.CONFIRM]: "OK",

  // 支付
  [LANGUAGE_KEY.SELECT_PAYMENT_METHOD]: "Please select the payment method",
  [LANGUAGE_KEY.PAYMENT_BTN]: "Pay Now",
  [LANGUAGE_KEY.PAYMENT_ALIPAY]: "Alipay",
  [LANGUAGE_KEY.PAYMENT_WECHAT]: "WeChat Pay",
  [LANGUAGE_KEY.PAYMENT_HUABEI]: "Huabei",
  [LANGUAGE_KEY.PAYMENT_ALIPAY_QRCODE]: "Alipay",
  [LANGUAGE_KEY.PAYMENT_WECHAT_QRCODE]: "WeChat Pay",
  [LANGUAGE_KEY.PAYMENT_APPLE]: "Apple Pay",
  [LANGUAGE_KEY.PAYMENT_APPLE_STOREKIT2]: "Apple StoreKit 2",
  [LANGUAGE_KEY.PAYMENT_ONE_STORE]: "OneStore",
  [LANGUAGE_KEY.PAYMENT_HUAWEI_OVERSEAS]: "Huawei",
  [LANGUAGE_KEY.PAYMENT_SANSUNG]: "Samsung Pay",
  [LANGUAGE_KEY.PAYMENT_AMAZON]: "Amazon",
  [LANGUAGE_KEY.PAYMENT_AIRWALLEX]: "Airwallex",
  [LANGUAGE_KEY.PAYMENT_THAILAND]: "UniPin",
  [LANGUAGE_KEY.PAYMENT_EUROPE_AMERICA]: "Xsolla",
  [LANGUAGE_KEY.PAYMENT_TAIWAN]: "MyCard",
  [LANGUAGE_KEY.PAYMENT_SOUTHEAST_ASIA]: "PayerMax",
  [LANGUAGE_KEY.PAYMENT_VIETANM]: "Upay",
  [LANGUAGE_KEY.PAYMENT_PAY_PAY]: "PayPay",
  [LANGUAGE_KEY.PAYMENT_PAY_PAL]: "PayPal",
  [LANGUAGE_KEY.PAYMENT_PAY_LETTER]: "PayLetter",
  [LANGUAGE_KEY.PAYMENT_WECHAT_JSSDK]: "WeChat Pay",
  [LANGUAGE_KEY.PAYMENT_WECHAT_H5]: "WeChat Pay",
  [LANGUAGE_KEY.PAYMENT_ALIPAY_MOBILE_WEB]: "Alipay",
  [LANGUAGE_KEY.PAYMENT_ALIPAY_PC_WEB]: "Alipay",
  [LANGUAGE_KEY.PAYMENT_ALIPAY_INTERNATIONAL_CARD]: "Visa/MasterCard",
  [LANGUAGE_KEY.PAYMENT_ALIPAY_INTERNATIONAL_GOOGLE]: "Google Pay",
  [LANGUAGE_KEY.PAYMENT_ALIPAY_INTERNATIONAL_PAYPAL]: "PayPal",
  [LANGUAGE_KEY.PAYMENT_ALIPAY_INTERNATIONAL_APPLE]: "Apple Pay",
  [LANGUAGE_KEY.PAYMENT_XSOLLA_PAYPAL]: "PayPal",
  [LANGUAGE_KEY.PAYMENT_ALIPAY_INTERNATIONAL]: "Antom",
  [LANGUAGE_KEY.PAYMENT_PAYERMAX_CARD]: "Card",
  [LANGUAGE_KEY.PAYMENT_PAYERMAX_GOOGLE]: "Google Pay",
  [LANGUAGE_KEY.PAYMENT_PAYERMAX_APPLE]: "Apple Pay",
  [LANGUAGE_KEY.PAYMENT_ENJOYPAY_CARD]: "Card",
  [LANGUAGE_KEY.PAYMENT_ENJOYPAY_APPLE]: "Apple Pay",
  [LANGUAGE_KEY.PAYMENT_ENJOYPAY_GOOGLE]: "Google Pay",
  [LANGUAGE_KEY.PAYMENT_ENJOYPAY_PAYPAY]: "PayPay",
};